<section class="questions-section" *ngIf="!isLoading">
  <div class="container">
    <!-- Progress Bar -->
    <div class="progress-bar" *ngIf="slideViews.length > 1">
      <div class="progress-fill" [style.width.%]="progressPercentage"></div>
    </div>

    <div class="question-container">
      <!-- Slide Counter -->
      <div class="question-counter" *ngIf="slideViews.length > 1">
        {{ "page.questionnaire.slideCounter" | translate: { current: currentSlideIndex + 1, total: slideViews.length } }}
      </div>

      <!-- Questionnaire Title -->
      <h2 class="form-title">{{ questionnaire.subjectType }}</h2>

      <!-- Questionnaire sub-title -->
      <p class="question-text" *ngIf="questionnaire.group.text">
        {{ questionnaire.group.text }}
      </p>

      <!-- Slide Title -->
      <h2 class="slide-title">{{ currentSlide.title }}</h2>

      <!-- Slide Description -->
      <p class="slide-text" *ngIf="currentSlide.description">
        {{ currentSlide.description }}
      </p>

      <!-- Questions in current slide -->
      <ng-container *ngFor="let questionView of currentSlide.questions">
        <div *ngIf="isQuestionEnabled(questionView.question, questionView.response)" class="question-block" #questionBlock>
          <app-encode-question
            [question]="questionView.question"
            [response]="questionView.response"
            [choices]="getChoices(questionView.question)"
            (answerChange)="onAnswerChanged(questionView)"
          ></app-encode-question>
        </div>
      </ng-container>

      <!-- Navigation Buttons -->
      <div class="navigation-buttons">
        <button *ngIf="!(currentSlideIndex === 0)" class="btn-secondary" (click)="previousSlide()">
          ← {{ "button.back" | translate }}
        </button>

        <div class="spacer" *ngIf="currentSlideIndex === 0"></div>

        <button *ngIf="!(currentSlideIndex === slideViews.length - 1)" class="btn-primary" [disabled]="!canProceed()" (click)="nextSlide()">
          {{ "button.next" | translate }} →
        </button>

        <button
          *ngIf="currentSlideIndex === slideViews.length - 1"
          class="btn-primary"
          [disabled]="!canProceed()"
          (click)="submitQuestionnaire()"
        >
          {{ "button.complete" | translate }} →
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container">
  <mat-spinner></mat-spinner>
  <p>{{ "page.questionnaire.loading" | translate }}</p>
</div>
